module.exports = __webpack_public_path__ + "static/media/leader_notes.692e5ea9.pdf";